module.exports = __webpack_public_path__ + "static/media/twitter_cinza.7f10fedc.svg";